// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-screen-app{max-width:1008px;margin:0 auto;display:flex;justify-content:center;flex-direction:column;align-self:center;width:91%}`, "",{"version":3,"sources":["webpack://./src/matchScreen/styles/MatchScreenGeneral.scss"],"names":[],"mappings":"AAAA,kBACE,gBAAA,CACA,aAAA,CACA,YAAA,CACA,sBAAA,CACA,qBAAA,CACA,iBAAA,CACA,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
